import React from 'react';
import {assignProps} from '@sail/engine';
import {Action, Menu, MenuItem, Icon} from '@sail/ui';
import {more} from '@sail/icons/react/Icon';
import {defineMessages, FormattedMessage} from 'react-intl';
import {getStore} from 'src/v2/state/store';
import {useDisconnectWallet} from 'src/v2/components/pay/useDisconnectWallet';
import {COLORS} from 'src/v2/util/color';

const messages = defineMessages({
  changeNetwork: {
    id: 'crypto.payins.v2.pay_screen.change_network',
    description: 'Menu option to change the blockchain network',
    defaultMessage: 'Change network',
  },
  changeWallet: {
    id: 'crypto.payins.v2.pay_screen.change_wallet',
    description: 'Menu option to change the wallet',
    defaultMessage: 'Change wallet',
  },
  disconnectWallet: {
    id: 'crypto.payins.v2.pay_screen.disconnect_wallet',
    description: 'Menu option to disconnect the wallet',
    defaultMessage: 'Disconnect wallet',
  },
});

export const WalletActionMenu = ({disabled = false}: {disabled?: boolean}) => {
  const store = getStore();
  const disconnectWallet = useDisconnectWallet();

  const activeWallet = store.useSelector(
    (state) => state.walletConnection.activeWallet,
  );

  const connectedWallets = store.useSelector(
    (state) => state.walletConnection.connectedWallets,
  );

  const handleChangeNetwork = () => {
    store.setValue((state) => {
      state.screen = 'NETWORK_SWITCH';
    });
  };

  const handleChangeWallet = () => {
    store.setValue((state) => {
      state.screen =
        connectedWallets.length > 1 ? 'WALLET_SWITCH' : 'WALLET_SELECT_GRID';
    });
  };

  const handleDisconnectWallet = () => {
    if (!activeWallet) {
      return;
    }

    disconnectWallet(activeWallet);
  };

  return (
    <Menu
      trigger={
        <Action
          disabled={disabled}
          css={{
            display: 'flex',
            borderRadius: 'xsmall',
            padding: 'xsmall',
            backgroundColor: disabled ? COLORS.offsetHoverOnLight : undefined,
            ':hover': {
              cursor: disabled ? 'default' : 'pointer',
            },
            color: disabled ? COLORS.textDisabledOnLight : undefined,
          }}
        >
          <Icon icon={more} size="xsmall" />
        </Action>
      }
      subviews={{
        popover: {uses: [assignProps({placement: 'bottom left'})]},
      }}
    >
      {activeWallet?.network !== 'solana' ? (
        <MenuItem onAction={handleChangeNetwork}>
          <FormattedMessage {...messages.changeNetwork} />
        </MenuItem>
      ) : null}
      <MenuItem onAction={handleChangeWallet}>
        <FormattedMessage {...messages.changeWallet} />
      </MenuItem>
      <MenuItem onAction={handleDisconnectWallet} type="destructive">
        <FormattedMessage {...messages.disconnectWallet} />
      </MenuItem>
    </Menu>
  );
};
